import { render, staticRenderFns } from "./buyAgentCard.vue?vue&type=template&id=1f06327a&scoped=true&"
import script from "./buyAgentCard.vue?vue&type=script&lang=js&"
export * from "./buyAgentCard.vue?vue&type=script&lang=js&"
import style0 from "./buyAgentCard.vue?vue&type=style&index=0&id=1f06327a&lang=less&scoped=true&"
import style1 from "./buyAgentCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06327a",
  null
  
)

export default component.exports